<template>
  <div class="main-component-container">

    <div class="header-banner-bar" v-if="prodsbanneroriginal?.length > 0">
      <div class="row w-100 g-0">

        <!-- ACTUALIZADOS -->
        <div class="col-12 col-md-3 header-col-actualizados d-flex flex-column justify-content-center text-center p-3">
          <h4 class="mb-1 text-dark"><b>ACTUALIZADOS</b></h4>
          <p class="subtitle-p mb-0 text-dark">LISTADO DE PRODUCTOS ACTUALIZADOS</p>
        </div>

        <!-- CATEGORÍAS / MARCAS -->
        <div
          class="col-12 col-md-9 header-col-categorias d-flex align-items-stretch justify-content-start overflow-auto">
          <div class="tabs-scroll d-flex">
            <button v-for="(tab, index) in prodsbanneroriginal" :key="index" @click="changeTab(index)"
              :class="{ 'active-gsp-tab': isActiveTab(index) }"
              class="btn-categoria-gsp d-flex flex-column justify-content-center align-items-center text-center">
              <!-- Mostrar imagen si existe -->
              <img v-if="tab.image" :src="`/img/marcas/${tab.image}`" class="categoria-img mb-1"
                style="max-height: 40px; object-fit: contain;" />

              <!-- Fallback sin imagen -->
              <template v-else>
                <span class="categoria-label">{{ getCategoryName(tab.nombre) }}</span>
                <span class="marca-logo">{{ getBrandName(tab.nombre) }}</span>
              </template>
            </button>
          </div>
        </div>

      </div>
    </div>


    <div style="margin-top: 1%;" v-if="currentVisibleProducts?.length > 0">

      <div class="d-flex justify-content-between align-items-center product-slider-container">

        <button v-if="prodsbanneroriginal[currentIndex]?.Prods.length > pageSize" @click="slideProducts(-1)"
          class="slider-control-btn left-arrow" :disabled="prodsbanneroriginal[currentIndex]?.Prods.length <= pageSize">
          &lt;
        </button>

        <div class="product-track-viewport">
          <div :key="currentIndex + '-' + startIndex" class="d-flex product-track-inner">

            <div v-for="(producto, pIndex) in currentVisibleProducts" :key="producto.k_parte"
              class="product-item-wrapper col-12 col-md-4 col-lg-3">
              <cardprods :item="producto" />
            </div>
          </div>
        </div>

        <button v-if="prodsbanneroriginal[currentIndex]?.Prods.length > pageSize" @click="slideProducts(1)"
          class="slider-control-btn right-arrow"
          :disabled="prodsbanneroriginal[currentIndex]?.Prods.length <= pageSize">
          &gt;
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import cardprods from '../components/navegation/ComponentsRecomend/PresentacionProductos/cardsprods2.vue'
export default {
  props: {
    Itemsbar: {
      type: Object,
    },
  },
  components: {
    cardprods
  },
  data: () => ({
    prodsbanner: { Prods: [] },
    prodsbanneroriginal: [],
    currentIndex: 0,

    // VARIABLES PARA EL CARRUSEL MANUAL
    pageSize: 4,     // Productos visibles (4 ítems)
    startIndex: 0,   // Índice de inicio de la vista actual
  }),

  computed: {
    currentVisibleProducts() {
      if (!this.prodsbanneroriginal[this.currentIndex] ||
        !this.prodsbanneroriginal[this.currentIndex].Prods) {
        return [];
      }

      const activeProds = this.prodsbanneroriginal[this.currentIndex].Prods;
      const totalItems = activeProds.length;

      if (totalItems <= this.pageSize) {
        return activeProds;
      }

      let products = [];
      for (let i = 0; i < this.pageSize; i++) {
        const itemIndex = (this.startIndex + i) % totalItems;
        products.push(activeProds[itemIndex]);
      }

      return products;
    }
  },

  methods: {
    updatePageSize() {
      const width = window.innerWidth;

      if (width >= 1200) {
        this.pageSize = 4;      // desktop grande
      } else if (width >= 768) {
        this.pageSize = 3;      // tablets
      } else {
        this.pageSize = 1;      // celulares
      }
    },
    changeTab(index) {
      if (!this.prodsbanneroriginal[index]) return;
      this.currentIndex = index;
      this.prodsbanner = this.prodsbanneroriginal[index];
      this.startIndex = 0;
    },
    isActiveTab(tabIndex) {
      return this.currentIndex === tabIndex;
    },

    slideProducts(direction) {
      if (!this.prodsbanneroriginal[this.currentIndex]) return;
      const totalItems = this.prodsbanneroriginal[this.currentIndex].Prods.length;

      if (totalItems <= this.pageSize) return;

      let newIndex = this.startIndex + direction;

      if (newIndex >= totalItems) {
        newIndex = 0;
      } else if (newIndex < 0) {
        newIndex = totalItems - 1;
      }

      this.startIndex = newIndex;
    },

    getCategoryName(fullName) {
      if (!fullName) return '';
      const parts = fullName.split(' ');
      return parts.length > 1 ? parts.slice(1).join(' ').toUpperCase() : fullName.toUpperCase();
    },
    getBrandName(fullName) {
      if (!fullName) return '';
      const parts = fullName.split(' ');
      return parts.length > 0 ? parts[0].toUpperCase() : '';
    },
    formatItem(value) {
      if (!value) {
        return "";
      }
      const formattedText = value.replace(/\s+/g, '<br>');
      const coloredText = `<span style="color: #556E7C;font-size: 12px;">${formattedText}</span>`;
      return coloredText;
    },

    ObtenerProds() {
      // Usamos el código de Axios que tenías en tu código original
      axios.get('/controllerpeticiones/prodsbanner').then((response) => {
        const sucursales = response.data.filtrado;
        console.log(response.data.filtrado);
        this.prodsbanneroriginal = sucursales.filter(sucursal => sucursal.Prods && sucursal.Prods.length > 0);

        if (this.prodsbanneroriginal.length > 0) {
          this.prodsbanner = this.prodsbanneroriginal[this.currentIndex] || this.prodsbanneroriginal[0];
          if (!this.prodsbanner) {
            this.currentIndex = 0;
            this.prodsbanner = this.prodsbanneroriginal[0];
          }
        }
      })
        .catch(error => {
          console.error("Error al obtener productos:", error);
        });
    }
  },

  mounted() {
    this.ObtenerProds()
    this.updatePageSize();
    window.addEventListener("resize", this.updatePageSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updatePageSize);
  },
};
</script>

<style scoped>
/* ------------------------------------------- */
/* --- ESTILOS PARA LA BARRA DE NAVEGACIÓN --- */
/* ------------------------------------------- */

/* Contenedor principal para toda la barra */

/* 1. Columna 'ACTUALIZADOS' */
.header-col-actualizados {
  background-color: white;
  min-width: 150px;
  border-right: 2px solid #555;
}

.header-col-actualizados h4 {
  font-size: 1.1rem;
  font-weight: 800;
}

.header-col-actualizados .subtitle-p {
  font-size: 0.7rem;
  color: #888;
  font-weight: 600;
}

.header-col-categorias {
  background-color: #444;
  overflow-x: auto;
  white-space: nowrap;
}

/* Contenedor interno para mantener línea contínua */
.tabs-scroll {
  display: flex;
  flex-wrap: nowrap;
}

/* Botones responsivos */
.btn-categoria-gsp {
  background: none;
  border: none;
  border-right: 1px solid #555;
  color: white;
  min-width: 100px;
  padding: 8px 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: normal;
  /* permite dos líneas de texto */
}

/* Activo */
.active-gsp-tab {
  background-color: #333 !important;
  font-weight: bold;
}

/* Hover */
.btn-categoria-gsp:hover {
  background-color: #555;
}

/* Ajustes tipográficos */
.categoria-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.marca-logo {
  font-size: 0.9rem;
  font-weight: 900;
}

/* ------------------------------------------- */
/* --- SIMULACIÓN MANUAL DEL CARRUSEL --- */
/* ------------------------------------------- */

/* Contenedor principal del slider (para posicionamiento de flechas) */
.product-slider-container {
  position: relative;
  padding: 0 35px;
}

/* El 'viewport' que oculta los ítems que se salen */
.product-track-viewport {
  width: 100%;
  overflow: hidden;
  position: relative;
}

/* La "pista" interna que contiene los 4 ítems */
.product-track-inner {
  display: flex;
  transition: all 0.5s ease-in-out;
}

/* Define el ancho de cada tarjeta (100% dividido por 4) */
.product-item-wrapper {
  flex: 0 0 25%;
  /* 1/4 del ancho */
  padding: 0 5px;
  box-sizing: border-box;
}

/* Estilos para los botones de navegación */
.slider-control-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.2s;
  line-height: 1;
  padding-bottom: 3px;
}

.slider-control-btn:hover:not(:disabled) {
  background-color: #333;
}

.slider-control-btn:disabled {
  opacity: 0.3;
  cursor: default;
  background-color: #555;
}

.left-arrow {
  left: 0;
}

.right-arrow {
  right: 0;
}


/* ------------------------------------------- */
/* --- ESTILOS DE PRODUCTO --- */
/* ------------------------------------------- */
.product-frame {
  object-fit: contain;
  width: 100%;
}

.fixed-slide-height .card-body {
  padding: 0.5rem;
}

.product-track-inner {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
  /* carrusel sin salto */
}

.product-item-wrapper {
  padding: 5px;
  flex: 0 0 auto;
  /* evita que cambie tamaño */
}

@media (max-width: 767px) {
  .header-col-actualizados {
    order: -1;
    /* Forzamos a ir arriba */
    border-right: none;
    border-bottom: 2px solid #555;
  }
}
</style>